export enum Runtime {
  Prod,
  Staging,
  Test,
  Dev,
  Local,
}

export const runtime = (() => {
  const host = window.location.host;
  if (/\.dev\.sankuai\.com/.test(host)) {
    return Runtime.Dev;
  } else if (/\.test\.sankuai\.com/.test(host)) {
    return Runtime.Test;
  } else if (/\.st\.(sankuai|meituan)\.com/.test(host)) {
    return Runtime.Staging;
  } else if (/\.meituan\.com/.test(host)) {
    return Runtime.Prod;
  } else {
    return Runtime.Local;
  }
})();
